import { AbstractControl, ValidationErrors } from '@angular/forms';

export function cuitValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value: string = control.value;
  if (!value) {
    return null;
  }

  const digits = value.replace(/-/g, '');
  if (!/^\d{11}$/.test(digits)) {
    return { cuitInvalid: true };
  }

  const multipliers = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  const sum = multipliers.reduce(
    (acc, multiplier, index) => acc + parseInt(digits[index]) * multiplier,
    0
  );

  const checkDigit = 11 - (sum % 11);
  const expectedCheck =
    checkDigit === 11 ? 0 : checkDigit === 10 ? 9 : checkDigit;

  return parseInt(digits[10]) === expectedCheck ? null : { cuitInvalid: true };
}
